
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 40 40"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M33.72 14.4a6 6 0 00-1.11-2.78 4 4 0 00-2.81-1.18c-3.92-.29-9.79-.29-9.79-.29s-5.87 0-9.79.29a4 4 0 00-2.81 1.18 6 6 0 00-1.13 2.78A42.44 42.44 0 006 18.93v2.13a42.44 42.44 0 00.28 4.53 6 6 0 001.11 2.78 4.82 4.82 0 003.09 1.2c2.24.21 9.52.28 9.52.28s5.88 0 9.8-.3a4 4 0 002.81-1.18 6 6 0 001.11-2.78 42.44 42.44 0 00.28-4.53v-2.13a42.44 42.44 0 00-.28-4.53zm-16.61 9.23v-7.87l7.56 4z"}})])
          )
        }
      }
    